import { ViewModel, View, ObservableArray } from "binder"
import { WorkingShiftEditorView } from "./workingShiftEditor-view"
import { IWorkingShift } from "../IWorkingShift";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { TimeSelectorViewModel } from "uicomponents";
import { TimePart } from "src/uicomponents/components/timeSelector/timeSelector-viewModel";
import moment from "moment";

export class WorkingShiftEditorViewModel extends ViewModel implements IWorkingShift, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._serverUpdater = updater;


    }
    GetDefaultView(): View<ViewModel> {
        return new WorkingShiftEditorView();
    }
    public getTypeId(): string {
        return "VM-AE03BD2E-E38A-4D77-8CC4-E5458D98E1FA"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set shiftName(v: string) { this._shiftName = v; } public get shiftName(): string { return this._shiftName; } private _shiftName: string;
    public set startTime(v: moment.Moment) { this._startTime = v; } public get startTime(): moment.Moment { return this._startTime;} private _startTime: moment.Moment;
    public set endTime(v: moment.Moment) { this._endTime = v; } public get endTime(): moment.Moment { return this._endTime;} private _endTime: moment.Moment;
        

    closePopup(result?: any) {

    }

    async cloneTo(workingShift: IWorkingShift) {
        workingShift.id = this.id;
        workingShift.shiftName = this.shiftName;
        workingShift.startTime = this.startTime;
        workingShift.endTime = this.endTime;
    }

    back() {
        this.closePopup(null);
    }

    async save() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت شیفت کاری');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this);
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess('شیفت کاری با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            }
            catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت شیفت کاری', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.shiftName)) {
            result.push('نام شیفت مشخص نشده است.');
        }
        // if (this.startTimeMinute == null || this.startTimeHour == null) {
        //     result.push('ساعت شروع مشخص نشده است.');
        // }
        // if (this.endTimeMinute == null || this.endTimeHour == null) {
        //     result.push('ساعت پایان مشخص نشده است.');
        // }

        return result;
    }
}

export interface IServerUpdater {
    execute(workingShift: IWorkingShift): Promise<any>;
}

export class WorkingShiftInserter implements IServerUpdater {
    async execute(workingShift: IWorkingShift): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/WorkingShiftServices/CreateWorkingShift', {
                Name: workingShift.shiftName,
                StartTime: workingShift.startTime,
                EndTime: workingShift.endTime
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class WorkingShiftUpdater implements IServerUpdater {
    async execute(workingShift: IWorkingShift): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/WorkingShiftServices/UpdateWorkingShift', {
                WorkingShiftId: workingShift.id,
                Name: workingShift.shiftName,
                StartTime: workingShift.startTime,
                EndTime: workingShift.endTime
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}
